import BaseItem, { Rarity } from './base_item';

export default class Han extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "han.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15;}
    static get height() { return 8;}

    static get mass() { return 2;}
    static get rarity() { return Rarity.RARE; }
    static get electronic() { return false; }


    static get type() { return 'han'}
    static get label() { return 'Carbonite slab'}
    static get description() { return `He should be quite well protected.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/han.js